document.addEventListener("DOMContentLoaded", () => {

        function handleUrlHashChange(path, hash) {
            if (path.includes("/pages/faqs-order") && hash) {
                document.querySelector(`[href="#${hash}"]`).click();
                 // Scroll to top
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });

            } else if(!path.includes("/pages/faqs-order") && hash) {
            
                const el = document.querySelector(`#${hash}`);
                if (el) {
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 150;
                    window.scrollTo({
                        top: y,
                        behavior: "smooth"
                    });
                }
            }
        }

        // Run once on page load
        handleUrlHashChange(window.location.pathname, window.location.hash.substring(1));

        document.body.addEventListener("click", function (e) {

            if (e.target.closest("a") && !e.target.closest(".sidebar-navigation a") && e.target.closest("a").getAttribute("href")?.includes("#") ) {
                const path = e.target.closest("a").getAttribute("href")
                const hash = e.target.closest("a").getAttribute("href").split("#")[1];
                setTimeout(()=>{
                    handleUrlHashChange(path, hash);
                }) 
            }
        })

        function checkRegisterFields() {
           
            setTimeout(()=>{
                const name = document.querySelector('[name="first_name"]').value             
                const lastName = document.querySelector('[name="last_name"]').value;
                const address = document.querySelector('[name="default_address.country"]').value;
                const email = document.querySelector('[name="email"]').value; 
                const privacy = document.querySelector('[name="privacy_checkbox"]').value;

                
                if(name && name != "" && lastName && lastName != "" && address && address !="" && email && email != "" && privacy && privacy != "" && privacy != "false") {
                   
                    document.querySelector("button.cf-submit-form.cf-button.btn.button").removeAttribute("disabled");
                }
            }, 1000)
                
        }

         if(document.querySelector("#create_customer")) { 
            // Also trigger when the form is focused (helps for late autofill)
            document.querySelector("#create_customer").addEventListener('focusin', checkRegisterFields);
         }
})